import { render, staticRenderFns } from "./AddDressModal.vue?vue&type=template&id=81d29780&scoped=true"
import script from "./AddDressModal.vue?vue&type=script&lang=js"
export * from "./AddDressModal.vue?vue&type=script&lang=js"
import style0 from "./AddDressModal.vue?vue&type=style&index=0&id=81d29780&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d29780",
  null
  
)

export default component.exports